import { Component } from '@angular/core';

@Component({
  selector: 'app-cards3-examples-16',
  templateUrl: './cards3-examples-16.component.html'
})
export class Cards3Examples16Component {}
